import * as React from "react";
import classnames from "classnames";

const styles = require('./Toolbar.scss');
export const Toolbar = (props: React.HTMLProps<HTMLDivElement>) => {
    const { className, children, ...divProps } = props;
    return (
        <div className={classnames(styles.Toolbar, props.className)} {...divProps}>
            {children}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/app/components/Toolbar/index.tsx